import LegalPage from './LegalPage';

const SECTIONS = [
    {
        h: 'Éditeur du site',
        body: `Le site Mon Éclora est édité par :

Mélanie PEYRE
Entrepreneur individuel — régime micro-entreprise
Nom commercial : Mon Éclora
SIRET : 802 555 987 00022

Adresse professionnelle :
1 bis chemin Belloc, 33530 Bassens

Email :
contact@mon-eclora.fr

Directrice de la publication :
Mélanie PEYRE`,
    },
    {
        h: 'Hébergement',
        body: `Le site est hébergé par :
OVH
OVH SAS, société par actions simplifiée au capital de 10 174 560 € — RCS Lille Métropole 424 761 419 00045
2 rue Kellermann, 59100 Roubaix, France
Téléphone : 1007
Site internet : www.ovhcloud.com`,
    },
    {
        h: 'Propriété intellectuelle',
        body: `Sauf mention contraire, l'ensemble des contenus présents sur le site Mon Éclora, notamment les textes, éléments graphiques, illustrations, workbooks, méthodes, ressources, logos, identité visuelle et contenus éditoriaux, est protégé par les règles applicables en matière de propriété intellectuelle.

Toute reproduction, représentation, adaptation, diffusion ou exploitation non autorisée de ces contenus est interdite, sous réserve des exceptions prévues par la législation applicable.

Les marques, noms commerciaux et signes distinctifs appartenant à des tiers restent la propriété de leurs titulaires respectifs.`,
    },
    {
        h: 'Responsabilité',
        body: `Les contenus proposés par Mon Éclora ont une vocation informative, éducative et d'accompagnement personnel.

Ils ne constituent notamment pas un avis médical, psychologique, juridique ou financier et ne remplacent pas l'accompagnement d'un professionnel qualifié lorsque celui-ci est nécessaire.

Mon Éclora s'efforce de fournir des informations fiables et actualisées, sans pouvoir garantir l'absence totale d'erreurs ou d'omissions.`,
    },
    {
        h: 'Contact',
        body: `Pour toute question concernant le site :
contact@mon-eclora.fr`,
    },
];

export default function MentionsLegales() {
    return (
        <LegalPage
            title="Mentions légales"
            updated="septembre 2026"
            sections={SECTIONS}
            otherHref="/politique-de-confidentialite"
            otherLabel="Politique de confidentialité"
        />
    );
}
